module.exports = ".status {\n  display: inline-block;\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  background: #990909; }\n  .status.active {\n    background: #28c781; }\n  .status.normal {\n    width: 10px;\n    height: 10px; }\n  .status.big {\n    width: 19px;\n    height: 19px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/check-status/check-status.component.scss
// module id = ./src/app/shared/components/check-status/check-status.component.scss
// module chunks = main